import React from 'react';

const Footer = () => {
    return (
        <footer className="app-footer">
            <span className="d-inline-block"><a target="_blank" href="https://softencreative.com" rel="noreferrer">Soften Creative Solutions Pvt. Ltd.</a> &copy; {getYear()}</span>
        </footer>
    );
  }
;

const getYear = () => {
    const date = new Date();
    return date.getFullYear();
}

export default Footer;
